export interface ProfitabilityRiskInput {
  margin: number | null;
  opened_at: string | null;
  invoiced_ht: number | null;
}

const THREE_MONTHS_MS = 3 * 30 * 24 * 60 * 60 * 1000;

/**
 * Un dossier est « à surveiller » ssi les 3 conditions sont réunies :
 * - marge négative
 * - ouvert depuis plus de 3 mois
 * - au moins une facture émise
 */
export function isAtRisk(row: ProfitabilityRiskInput, now: Date): boolean {
  if (row.margin == null || row.margin >= 0) return false;
  if (row.invoiced_ht == null || row.invoiced_ht <= 0) return false;
  if (!row.opened_at) return false;
  const opened = new Date(row.opened_at).getTime();
  return now.getTime() - opened > THREE_MONTHS_MS;
}
